import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Container, WrapperMini, ContainerMini, Line, ContainerSVGMini, ButtonMaximizar, Title } from './index.styled';
import { setMenu, setMenuContent, setCurrentMap } from './../../../effects/actions'
import { Map } from '../../../components';
const menuMap = require('../../../assets/mock-data/menu-map.json')

const MapMiniComponent = React.memo(({ setMenu, setMenuContent, currentMap = null, setCurrentMap, currentSite }) => {
  const [map, setMap] = useState(null)
  useEffect(() => {
    if (!currentMap) return;
    const temp = menuMap.find((x) => x.items?.length > 0
      ? x.items.find(y => y.id === currentMap)
      : x.id === currentMap);
    setMap(temp);
  }, [currentMap])

  const handleMenu = () => {
    setMenu(true)
    setMenuContent('map')
    setCurrentMap(currentMap)
  }


  const title = () => {
    let t = (map?.items?.length > 0 ? map.items.find(x => x.id === currentMap)?.title : map?.title)
    switch (t) {
      case "info-wise.stone-inspire-700":
        return "info-wise.amorim-stone"
    
      default:
        return t
    } 
  }

  const title2 = title()
  return (
    <Container expanded={false}>
      <ContainerMini>
        <WrapperMini onClick={() => handleMenu()}>
          {/* <CompassSVGMini>
            {renderCompass()}
          </CompassSVGMini> */}

          <ContainerSVGMini>
            <Map name={currentMap} mini={true} currentSite={currentSite} />
            <ButtonMaximizar className="maximizar" />
          </ContainerSVGMini>

        </WrapperMini>

        {title2 && <Line />}
        {title2 && <Title><FormattedMessage id={title2} /></Title>}
      </ContainerMini>
    </Container>
  )
})

MapMiniComponent.propTypes = {
  str: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  type: PropTypes.string,
}

export default connect(null, {
  setMenu,
  setMenuContent,
  setCurrentMap
})(React.memo(MapMiniComponent))